import styled from 'styled-components';

const Container = styled.div`
	width: calc((100% - 600px) / 3);
	margin-right: 20px;
	overflow: auto;
	overflow-x: hidden;
	position: relative;
`;

const Collection = styled.div`
	margin-right: 20px;
	position: relative;
	background-color: ${props => props.active ? '#4A90E2' : 'white'};
	color: ${props => props.active ? 'white' : 'inherit'};
	box-shadow: ${props => props.active ? '0' : '0 2px 3px 0 rgba(0,0,0,0.2)'};
	border-radius: 2px;
	padding: 24px;
	margin-bottom: 20px;
	cursor: ${props => props.active ? 'cursor' : 'pointer'};
	transition: all 0.3s ease-out;

	${props => props.active ? '' : `
	&:hover {
    transform: translateY(-3px);
		box-shadow: 0px 8px 24px -8px rgba(60,60,60,0.3)
	}
	`}
`;

const Title = styled.p`
	margin-bottom: 8px;
`;

const DateString = styled.p`
	font-size: 12px;
	margin-bottom: 8px;

	&:nth-last-child(1) {
		margin-bottom: 0;
	}
`;

const Recipient = styled.p`
	font-size: 12px;
	white-space: nowrap;
	background-color: rgb(0,0,0,0.1);
	border-radius: 4px;
	padding: 4px 6px 3px;
	margin: 0 8px 2px 0;
	display: inline-block;
`;

const InlineButton = styled.button`
	position: absolute;
	top: 24px;
	right: 24px;
	background-color: rgba(0,0,0,0);
	border: 0;
	text-transform: uppercase;
	cursor: pointer;
	padding: 0;

	${props => props.active ? `
	color: white;
	` : ''}
`;

const CollectionSent = styled.span`
	position: absolute;
	bottom: 24px;
	right: 24px;
`;

export {
	Container,
	Collection,
	Title,
	DateString,
	Recipient,
	InlineButton,
	CollectionSent
}
